export default __webpack_public_path__ + "static/media/dettagli1.84937323.jpg";